export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14277.ce2b89c8.jpg";